import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Row from '../../../shared/components/Row';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { TaskDateInput } from '../list/components/TaskDateInput';
import ConstructionAutocomplete from '../../../shared/components/ConstructionAutocomplete';
import { FormSubmit } from '../../../shared/components/FormSubmit';
import CompanyAutocomplete from '../../../shared/components/CompanyAutocomplete';

const FORM = {
    NAME: 'MyOutsourcesTaskForm',
    FIELDS: {
        DATE: 'date',
        COMPANY: 'company_id',
        CONSTRUCTION: 'construction_id',
    },

};

const INIT_STATE = {
    date: '',
    showErrorDate: false,
    showErrorInvalidDate: false,
    year: -1,
    month: -1,
    showErrorConstruction: false,
    constructionId: -1,
    showErrorCompany: false,
    companyId: -1,
};

class TaskFormContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...INIT_STATE,
        };
    }

    onChangeDate = (date) => {
        if ( ( date.length === 7 && date.indexOf('/') === 2 ) || ( date.length === 6 && date.indexOf('/') === 1 ) ) {
            const dates = date.split('/');
            try {
                const month = parseInt(dates[0], 10);
                const year = parseInt(dates[1], 10);
                this.setState({ month, year, showErrorDate: false, showErrorInvalidDate: false });
            } catch (e) {
                this.setState({
                    month: INIT_STATE.month,
                    year: INIT_STATE.year,
                    showErrorInvalidDate: true,
                    showErrorDate: false,
                });
            }
        } else if ( date.length === 0 ) {
            this.setState({
                month: INIT_STATE.month,
                year: INIT_STATE.year,
                showErrorDate: true,
                showErrorInvalidDate: false,
            });
        } else {
            this.setState({
                month: INIT_STATE.month,
                year: INIT_STATE.year,
                showErrorInvalidDate: true,
                showErrorDate: false,
            });
        }
    };

    onChangeConstruction = (construction) => {
        if ( construction && construction.length !== 0 ) {
            this.setState({ constructionId: construction[0].id, showErrorConstruction: false });
        } else {
            this.setState({ constructionId: INIT_STATE.constructionId, showErrorConstruction: true });
        }
    };

    onChangeCompany = (company) => {
        if ( company && company.length !== 0 ) {
            this.setState({ companyId: company[0].id, showErrorCompany: false });
        } else {
            this.setState({ companyId: INIT_STATE.companyId, showErrorCompany: true });
        }
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const { onSubmit } = this.props;
        const {
            year,
            month,
            constructionId,
            companyId,
        } = this.state;

        const existErrors = false;
        if ( year === INIT_STATE.year || month === INIT_STATE.month ) {
            this.setState({ showErrorDate: true });
        }
        if ( constructionId === INIT_STATE.constructionId ) {
            this.setState({ showErrorConstruction: true });
        }
        if ( companyId === INIT_STATE.companyId ) {
            this.setState({ showErrorCompany: true });
        }
        if ( !existErrors ) {
            onSubmit({
                year,
                month,
                constructionId,
                companyId,
            });
        }
    };

    render() {
        const {
            showErrorDate,
            showErrorInvalidDate,
            showErrorConstruction,
            showErrorCompany,
            year,
            month,
            constructionId,
            companyId,
        } = this.state;
        const disabledSubmit =
            year === INIT_STATE.year ||
            month === INIT_STATE.month ||
            constructionId === INIT_STATE.constructionId ||
            companyId === INIT_STATE.companyId;

        return (
            <form onSubmit={this.handleSubmit}>
                <Row>
                    <div className={'col-md-3'}>
                        <div className="form-group">
                            <label>{I18nUtils.tr('TR_FECHA')}</label>
                            <div className={'form-line'}>
                                <Field
                                    name={FORM.FIELDS.DATE}
                                    component={TaskDateInput}
                                    handleSetDate={this.onChangeDate}
                                />
                            </div>
                            {( showErrorDate || showErrorInvalidDate ) &&
                                <label className="error">
                                    {I18nUtils.tr(
                                        showErrorDate ? 'TR_CAMPO_OBLIGATORIO' : 'TR_FECHA_INVALIDA')}
                                </label>
                            }
                        </div>
                    </div>
                </Row>
                <Row>
                    <div className={'col-md-6'}>
                        <div className="form-group">
                            <label>{I18nUtils.tr('TR_OBRA')}</label>
                            <div className={'form-line'}>
                                <ConstructionAutocomplete onChange={this.onChangeConstruction}/>
                            </div>
                            {showErrorConstruction &&
                                <label className="error">
                                    {I18nUtils.tr('TR_CAMPO_OBLIGATORIO')}
                                </label>
                            }
                        </div>
                    </div>
                    <div className={'col-md-6'}>
                        <div className="form-group">
                            <label>{I18nUtils.tr('TR_SUBCONTRATA')}</label>
                            <div className={'form-line'}>
                                <CompanyAutocomplete onChange={this.onChangeCompany}/>
                            </div>
                            {showErrorCompany &&
                                <label className="error">
                                    {I18nUtils.tr('TR_CAMPO_OBLIGATORIO')}
                                </label>
                            }
                        </div>
                    </div>
                </Row>
                <Row>
                    <Field
                        label={I18nUtils.tr('TR_GUARDAR')}
                        name="submit"
                        col="col-md-6 col-md-offset-6"
                        component={FormSubmit}
                        disabled={disabledSubmit}
                    />
                </Row>
            </form>
        );
    }
}

export const TaskForm = reduxForm(
    {
        form: FORM.NAME,
    },
)(TaskFormContent);

TaskForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

TaskForm.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/form/TaskForm.jsx